import React from "react";
import { SpinnerStyle } from "./styles.module";
import { keyframes, css } from "@emotion/css";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1 }
  45% { transform: scale(0.1); opacity: 0.7 }
  80% { transform: scale(1); opacity: 1 }
`;

interface IIconProps {
  classWrapper?: string;
  className?: string;
  margin?: number;
  color?: string;
  size?: number;
  fit?: boolean;
}

export class Spinner extends React.Component<IIconProps> {
  style(i: number) {
    const { color, size, margin } = this.props;
    const speedMultiplier = 1;

    return css`
      background-color: ${color || "blue"};
      width: ${size || 10}px;
      height: ${size || 10}px;
      margin: ${margin || 2}px;
      border-radius: 100%;
      display: inline-block;
      animation: ${pulse} ${0.75 / speedMultiplier}s
        ${(i * 0.12) / speedMultiplier}s infinite
        cubic-bezier(0.2, 0.68, 0.18, 1.08);
      animation-fill-mode: both;
    `;
  }

  render() {
    const fitCls = this.props.fit ? "spinner__fit" : "";
    const wrapperCls = this.props.classWrapper ? this.props.classWrapper : "";

    return (
      <SpinnerStyle className={`${wrapperCls} ${fitCls}`}>
        <div className="spinner__item">
          <span>
            <span className={this.style(1)}></span>
            <span className={this.style(2)}></span>
            <span className={this.style(3)}></span>
          </span>
        </div>
      </SpinnerStyle>
    );
  }
}
